// Pathfinder Unchained Variant Multiclassing — Barbarian archetype benefit tiers.
const barbarianArchetype = [
  {
    level: 3,
    name: 'Rage',
    description: 'You gain the rage class feature for a number of rounds per day equal to your Constitution modifier + your character level.',
  },
  {
    level: 7,
    name: 'Uncanny Dodge',
    description: 'You gain uncanny dodge.',
  },
  {
    level: 11,
    name: 'Rage Power',
    description: 'You gain a rage power. For the purpose of which rage powers you can select, your effective barbarian level is equal to 1/2 your character level, but for the purpose of the rage power\'s effect, your effective barbarian level is equal to your full character level.',
  },
  {
    level: 15,
    name: 'Damage Reduction',
    description: 'You gain DR 3/—.',
  },
  {
    level: 19,
    name: 'Greater Rage',
    description: 'You gain greater rage.',
  },
];

export default barbarianArchetype;
